<template>
    <div id="cyclic-definition_create">
        <v-dialog
                max-width="290"
                persistent
                v-model="dialog"
        >
            <v-card>
                <v-card-title class="headline">Wybierz czestotlowość</v-card-title>
                <v-card-text>
                    <v-slider
                            :disabled="specialInterval"
                            label="Czestotliwosc"
                            thumb-label="always"
                            v-model="form.interval"
                    >
                    </v-slider>
                    <v-select
                            :disabled="specialInterval"
                            :items="unit"
                            item-text="name"
                            item-value="unit"
                            label="Jednostka czasu"
                            v-model="form.interval_unit"
                    ></v-select>
                    <v-checkbox
                            color="red"
                            label="Niestandardowo"
                            v-model="specialInterval"
                    >
                    </v-checkbox>
                </v-card-text>
                <v-card-text v-if="specialInterval">
                    <v-select
                            :items="specialUnit"
                            item-text="name"
                            item-value="unit"
                            label="Interwał"
                            v-model="form.special_interval"
                    ></v-select>


                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>


                    <v-btn
                            @click="confirmCyclic()"
                            color="green darken-1"
                            text
                    >
                        Zatwierdź
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-form
                lazy-validation
                ref="form"
        >
            <table>
                <tbody>
                <tr :key="schemasRow.name" v-for="schemasRow in schemas">
                    <td :key="schema.id" v-for="schema in schemasRow">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">

                                <v-checkbox
                                        :key="schema.id"
                                        :label="schema.name"
                                        :value="schema.id"
                                        @click.native="checboxClicked(schema.id)"
                                        color="red"
                                        v-model="checkboxSchemas"
                                        v-on="on"
                                >
                                </v-checkbox>

                            </template>
                            <span>{{ getIntervalTooltipMessage(schema.id) }}</span>
                        </v-tooltip>

                    </td>
                </tr>
                </tbody>
            </table>
        </v-form>
        <v-btn
                @click="submit"
                color="primary"
        >
            {{ $t('cyclic.continue') }}
        </v-btn>
    </div>
</template>

<script>
    import http from '@/plugins/http'

    export default {
        components: {},
        props: ["idCyclic", "cyclicSchemas"],
        data() {
            return {
                intervalRules: [v => !!v],
                basicValid: false,
                loading: false,
                specialInterval: false,
                dialog: false,
                baseSchemas: [],
                checkboxSchemas: (this.cyclicSchemas == undefined || !Array.isArray(this.cyclicSchemas)) ? [] : this.cyclicSchemas.map((schema) => parseInt(schema.id)),
                unit: [{"unit": "day", "name": "Dzień"}, {"unit": "month", "name": "Miesiąc"}],
                specialUnit: [{"unit": "once", "name": "Jednorazowo"}, {unit: "first", "name": "Na poczatki"}, {unit: "nolimit", "name": "No limit"}],
                form: {'interval_unit': "day", "interval": "1", "special_interval": "once"},
                schmeasToSend: (this.cyclicSchemas == undefined || !Array.isArray(this.cyclicSchemas)) ? [] : this.setUpCyclicSchemasToSend(this.cyclicSchemas),
                currentCheckedSchema: 0
            }
        },
        computed: {
            schemas() {
                return this.prepareForTableView(this.baseSchemas, 3)
            }
        },
        methods: {
            getIntervalTooltipMessage(idSchema) {
                let schemaInfo=this.schmeasToSend.find((el)=> el.schema_id==idSchema)

                if(schemaInfo == undefined || schemaInfo.interval== undefined){
                    return "Zaznacz, zeby wybrac czestotliwosc"
                }
                let splitInterval=schemaInfo.interval.split(" ")

                if(splitInterval.length==2)
                    return "Co "+ splitInterval[0]+" "+ this.unit.find((unit)=>unit.unit== splitInterval[1]).name
                if(splitInterval.length==1) {
                    let specUnit=this.specialUnit.find((unit) => unit.unit == splitInterval[0])

                    if(specUnit != undefined)
                        return specUnit.name
                }

                return "Bład"
            },
            checboxClicked(id) {
                if (this.checkboxSchemas.includes(id)) {
                    this.currentCheckedSchema = id;
                    this.dialog = true
                } else {
                    this.schmeasToSend = this.schmeasToSend.filter((cyclicSchema) => cyclicSchema.schema_id != id)
                }
            },
            confirmCyclic() {
                let interval;

                if (this.specialInterval)
                    interval = this.form.special_interval;
                else
                    interval = this.form.interval + " " + (this.form.interval_unit != undefined ? this.form.interval_unit : "day");

                this.schmeasToSend.push({"schema_id": this.currentCheckedSchema, "interval": interval});
                this.currentCheckedSchema = 0;
                this.dialog = false
            },
            loadSchemas() {
                this.loading = true;
                http.get('schemas')
                    .then(response => {
                        this.baseSchemas = response.data;
                        this.loading = false
                    }).catch(() => {
                    this.loading = false
                })
            },
            submit() {
                if (this.checkboxSchemas.length > 0) {
                    let postData = {
                        "schemas": this.schmeasToSend
                    };
                    http.post('cyclic/' + this.idCyclic + '/create-definition-schema', postData)
                        .then(({data}) => {
                            this.$emit("schema-assigned", data)
                        })
                }
            },
            noLimit() {
                this.schmeasToSend.push({"schema_id": this.currentCheckedSchema, "interval": "nolimit"});
                this.dialog = false
            },
            setUpCyclicSchemasToSend(cyclicSchemas) {
                let schmeasToSend = [];
                cyclicSchemas.forEach(cyclicSchema => schmeasToSend.push({
                    "schema_id": cyclicSchema.id,
                    "interval": cyclicSchema.interval
                }));
                return schmeasToSend
            },
            prepareForTableView(arr, columnNum) {
                let res = [];
                let tempArr = [];
                arr.forEach(el => {
                    tempArr.push(el);
                    if (tempArr.length == columnNum) {
                        res.push(tempArr);
                        tempArr = [];
                    }
                });
                if (tempArr.length > 0) {
                    res.push(tempArr)
                }
                return res
            }
        },
        created() {
            this.loadSchemas()
        }
    }
</script>

<style>
    table {
        table-layout: fixed;
        width: 100%;
    }

    td {
        width: 33%;
    }
</style>
